module.exports = __webpack_public_path__ + "img/1762059588153-az2cPxCy.98f60779.png";